import IndexedDB from "../IndexedDB";
import CodeValuesDB from "../IndexedDB/CodeValuesDB";

export const getTableValuesByGroupName = async (groupName?: string,sortByDescription:boolean=false): Promise<any[]> => {
    return IndexedDB.initDb().then(async () => {
        return await CodeValuesDB.GetCodeValueListByGroupname(groupName,sortByDescription);
    })
}

/**
 * Get all cities that belong to a given countyId
 * @param countyId - The countyId to filter cities by
 * @returns An array of city objects for the given county
 */
export const getCitiesByCountyId = async (countyId: number): Promise<any[]> => {
  return IndexedDB.initDb().then(async () => {
    // Fetch all cities
    const cities = await CodeValuesDB.GetCodeValueListByGroupname("City", false);
    console.log("getting cities:", cities);

    // We will compare against the county *name* (often a numeric string like "28").
    const targetName = String(countyId);

    // Filter:
    // - Active cities whose related county.name equals the requested value (as string)
    // - Keep the special "Not City" option (countyId == 1), as in the original logic
    const filteredCities = cities.filter((city: any) => {
      if (!city?.active) return false;

      // Prefer nested county.name if present; fallback to city.countyId (some data stored the county name here)
      const cityCountyName =
        city?.county?.name != null
          ? String(city.county.name)
          : city?.countyId != null
          ? String(city.countyId)
          : "";

      const isMatchByCountyName = cityCountyName === targetName;

      const isGlobalNotCity =
        Number(city?.countyId) === 1 && city?.description === "Not City";

      return isMatchByCountyName || isGlobalNotCity;
    });

    return filteredCities;
  });
};
